import React, {Component} from 'react';
import { Grid, Cell } from 'react-mdl';


class Education extends Component{
    render(){

        return(

            <div>
            
            <Grid>
            <Cell cols={4}> 
                <p> {this.props.startYear} - {this.props.endYear}</p>
            </Cell>
            <Cell cols={8}>
            <h4 style={{marginTop:'0px'}}>{this.props.collegeName}</h4>
            <p>{this.props.collegeDescription}</p>
            
            </Cell>
            
            </Grid>

                   
            
            
            </div>
        )
    }
}
export default Education;